type GreyFleetFormLayoutProps = {
    title?: string;
    subtitle?: string;
    description?: string;
    content: JSX.Element;
    buttons?: JSX.Element;
    company?: string;
    department?: string;
};

const GreyFleetFormLayout: React.FC<GreyFleetFormLayoutProps> = ({
    title,
    subtitle,
    description,
    buttons,
    content,
    company,
    department,
}) => {
    return (
        <>
            {title && <h1 className="text-3xl mb-3">{title}</h1>}
            {subtitle && (
                <h2 className="font-semibold text-lg mb-2">{subtitle}</h2>
            )}
            {description && <p className="mb-4">{description}</p>}
            {company && <p className="mb-4"><b>Company:</b> {company}</p>}
            {department && <p className="mb-4"><b>Department:</b> {department}</p>}
            {content}
            {buttons && <div className="mt-auto pt-6">{buttons}</div>}
        </>
    );
};

export default GreyFleetFormLayout;
